/**
 * Action type to signal the closing of the custom panel.
 */
export const CUSTOM_PANEL_CLOSE = 'CUSTOM_PANEL_CLOSE';
/**
 * Action type to signal the opening of the custom panel.
 */
export const CUSTOM_PANEL_OPEN = 'CUSTOM_PANEL_OPEN';
/**
 * Action type to enable or disable the custom panel dynamically.
 */
export const SET_CUSTOM_PANEL_ENABLED = 'SET_CUSTOM_PANEL_ENABLED';
/**
 * Action type to set the custom panel width (responsive adjustments).
 */
export const SET_CUSTOM_PANEL_WIDTH = 'SET_CUSTOM_PANEL_WIDTH';
/**
 * Action type to set the user-preferred custom panel width (user drag).
 */
export const SET_USER_CUSTOM_PANEL_WIDTH = 'SET_USER_CUSTOM_PANEL_WIDTH';
/**
 * Action type to indicate whether the custom panel is being resized.
 */
export const SET_CUSTOM_PANEL_IS_RESIZING = 'SET_CUSTOM_PANEL_IS_RESIZING';
